import React, { Component } from 'react'

import HSGStudentGrid from './HSGStudentGrid/HSGStudentGrid'
import HSGCard from '../../../Components/HSGCard/HSGCard'
import Phi from '../../../Phi/Phi'

import './StudentList.css'


class StudentList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            studentArr: []
        }
    }

    componentWillMount() {
        let organization = JSON.parse(Phi.Storage.getItem('organization'))
        if (organization) {
            if (this.props.currentProgram && Object.keys(this.props.currentProgram).length > 0) {
                let startNode = this.props.currentProgram.billing ? this.props.startNodeMap[this.props.currentProgram.billing.id] : null
                if (startNode) {
                    this.props.fetchStudentList(Object.assign({}, this.props.studentHeader, { startNode: startNode.id, inOffset: 0, inSearchString: '' }))
                }            
            }
            else {
                this.props.getProgramByOrganization(organization[0].org_id)
            }    
        }
                 
    }


    componentWillReceiveProps(newProps) {
        if (JSON.stringify(newProps.currentProgram) !== JSON.stringify(this.props.currentProgram)) {
            let startNode = newProps.startNodeMap[newProps.currentProgram.billing.id]
            this.props.fetchStudentList(Object.assign({}, this.props.studentHeader, { startNode: startNode.id }))
        }
    }

    customMultiSelect = props => {
        const { type, checked, disabled, onChange, rowIndex } = props
        if (rowIndex === 'Header') {
            return <div></div>
        } else return (
            <div className="hsg-checkbox-sm">
                <input
                    type={type}
                    name={'checkbox' + rowIndex}
                    id={'checkbox' + rowIndex}
                    checked={checked}
                    disabled={disabled}
                    onChange={e => onChange(e, rowIndex)}
                    ref={input => {
                        if (input) {
                            input.indeterminate = props.indeterminate;
                        }
                    }}
                />
                <label htmlFor={'checkbox' + rowIndex}>
                    <div className='check'></div>
                </label>
            </div>
        )
    }

    downloadStudentReport = (studentId, studentName, reportType = 'health_card') => {
        let startNode = this.props.startNodeMap[this.props.currentProgram.billing.id]
        this.props.getStudentReport(reportType, { startNodeId: startNode.id, studentName,studentId, type: 'pdf' })
    }

    downloadBulkStudentReport = () => {
        let startNode = this.props.startNodeMap[this.props.currentProgram.billing.id]
        this.props.getBulkStudentReport('all', { startNodeId: startNode.id, studentArr: this.state.studentArr, type: 'pdf' })
    }

    downloadAllStudentReport = () => {
        let startNode = this.props.startNodeMap[this.props.currentProgram.billing.id]
        let studentArr = this.props.studentList.map((student) => student.uuid)
        
        this.props.getBulkStudentReport('all', { startNodeId: startNode.id, studentArr, type: 'pdf' })
    }

    searchStudent(param) {
        let studentHeader = Object.assign({}, this.props.studentHeader)
        studentHeader.inSearchString = param;
        this.props.fetchStudentList(studentHeader)
    }

    showNext = where => {
        let { inLimit, inOffset } = this.props.studentHeader
        let { totalStudent, studentHeader } = this.props
        if (where === 'prev') {
            let newOffset = inOffset - inLimit < 0 ? 0 : inOffset - inLimit
            this.props.fetchStudentList(Object.assign({}, studentHeader, { inOffset: newOffset }))
        } else {
            if (inOffset >= totalStudent || (inOffset + inLimit) >= totalStudent) {
                return
            }
            let newOffset = inOffset + inLimit;
            this.props.fetchStudentList(Object.assign({}, studentHeader, { inOffset: newOffset }))
        }
    }
    
    render() {
        const { totalStudent, studentHeader, studentList } = this.props
        const { inOffset } = studentHeader
        const organization = JSON.parse(Phi.Storage.getItem('organization'))
        const organizationName = !!organization[0] ? organization[0].organization_name : ''
        return (
            <HSGCard full hideheader headingLeft={`All Student List of ${organizationName}`}>                                                    
                <div className="padding-left-1rem padding-right-1rem">
                    <HSGStudentGrid
                        offset={inOffset}
                        data={studentList}
                        downloadStudentReport={
                            (studentId, studentName, type) => 
                                this.downloadStudentReport(studentId, studentName, type)
                        }
                        search={(param) => this.searchStudent(param)}
                        organizationName={organizationName}
                        total={totalStudent}
                        showNext={this.showNext}
                    />
                </div>                                
            </HSGCard>
        )

        // return (
            // <Col lg={12} md={12} sm={12} xs={12}>
            //     <section className="hsg-student-container" style={{minHeight: this.props.dim.contentHeight}}>
            //         <Row className="show-grid">
            //             {/* Main Content */}
            //             <Col md={12} lg={12}>
                        /* </Col>
                    </Row>
                </section>
            </Col> */
        // )
    }

}

export default StudentList


// WEBPACK FOOTER //
// ./src/Containers/StudentListContainer/Component/StudentList.js